import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Spinner from '../Spinner';
import { useRouteTransition } from '../../utils/RouteTransitionContext';

import './styles.css';

const TransitionManager: React.FC = () => {
  const { isTransitioning, endTransition } = useRouteTransition();
  const location = useLocation();

  // Reset transition state when location changes
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      endTransition();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [location, endTransition]);

  if (!isTransitioning) {
    return null;
  }

  return (
    <div className='transition-overlay'>
      <Spinner hasText={false} />
    </div>
  );
};

export default TransitionManager;
